import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { HashLink } from 'react-router-hash-link';
import { NakedButton, Text, Heading, Icon } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { FAQS } from 'config';
import AppLink from 'components/AppLink';

const InlineLink = styled(AppLink)`
  color: ${themeGet('brand.primary')};
  text-decoration: underline;
`;

const QuestionLink = styled(NakedButton)`
  justify-content: space-between;
  align-items: center;
  background-color: ${themeGet('colors.white')};
  text-decoration: none;
  color: inherit;
  padding: ${themeGet('space.4')};
  margin-top: ${themeGet('space.5')};
  display: block;
  width: 75%;

  &:hover {
    text-decoration: underline;
    color: inherit;
  }
`;

const QuestionLinkWrapper = ({ children, questionId }) => {
  return (
    <QuestionLink as={HashLink} to={`/faqs/#${questionId}`} data-testid={`${questionId}`}>
      {children}
      <Icon ml={2} name="chevronRight" color="brand.primary"></Icon>
    </QuestionLink>
  );
};
QuestionLinkWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  questionId: PropTypes.string.isRequired,
};

const BookingConfirmationFaqsLinks = () => {
  return (
    <Fragment>
      <Heading.h2>Still looking for more information?</Heading.h2>
      <Text fontSize="md">
        Browse our <InlineLink to={FAQS}>frequently asked questions</InlineLink>
      </Text>
      <QuestionLinkWrapper questionId="documentation">What booking documentation do I need to check-in to the hotel?</QuestionLinkWrapper>
      <QuestionLinkWrapper questionId="change-booking">How do I change a booking?</QuestionLinkWrapper>
      <QuestionLinkWrapper questionId="cancel-booking">Can I cancel my booking?</QuestionLinkWrapper>
      <QuestionLinkWrapper questionId="cancellation-policy">
        What is a ‘free cancellation’ or ‘non-refundable’ cancellation?
      </QuestionLinkWrapper>
      <QuestionLinkWrapper questionId="feedback">What do I do if I have feedback?</QuestionLinkWrapper>
    </Fragment>
  );
};

export default BookingConfirmationFaqsLinks;
